import React, {useState} from 'react'
import UserIcon from '../UserIcon'
import VisDiv from '../frontend_components/VisDiv'
import DateLog from '../DateLog'
import RichTextEditor from '../RichTextEditor'
import { FaArrowAltCircleDown, FaArrowAltCircleUp } from "react-icons/fa";


/**
 * ReportAperturaEmail component
 * #emails
 * This component renders a list of users with their email and a button to test the report apertura email.
 * 
 * @param {Object} users - The users data
 * @param {Object} client - The client data
 * @returns {JSX} A JSX component with the list of users and the button to test the report apertura email
 */
const ReportAperturaEmail = ({users, client}) => {
    const usersWithEmail = !Array.isArray(users) ? [] : users?.filter?.((x)=>x?.emailComms?.length > 0)
    const testFunction = () => {
        console.log("jeidejiod", usersWithEmail, client)
    }
  return (
    <div>
      <button onClick={testFunction}>test report apertura email</button>  
      {usersWithEmail?.map?.((user, index)=> {
        return(
            <UserEmailPin index={index} key={user?._id} user={user}/>
        )
      })}
    </div>
  )
}

export default ReportAperturaEmail

/**
 * UserEmailPin component
 * This component renders a single user with their email and a button to expand or collapse the email list.
 * 
 * @param {string} title - The title of the user
 * @param {Object} user - The user data
 * @param {Object} client - The client data
 * @param {number} index - The index of the user in the list
 */
export const UserEmailPin = ({title, user={}, client, index}) => {
    const [toggleEmails, setToggleEmails] = useState(false)
    const rowColour = index % 2 ? "white":"#f3f4f3"
    //const emailComms = user?.emailComms ? user?.emailComms : client?.emailComms
    const {firstName, lastName, professionalTitle, emailComms} = user
    const userString = () => {
        const title = professionalTitle ? `${professionalTitle} ` : ""
        const name = firstName ? `${firstName} ` : ""
        const lname = lastName ? `${lastName} ` : ""
        return `${title}${name}${lname}`
    }
    const nEmails = `${emailComms?.length} email`
    return (
    <div onClick={()=>setToggleEmails(!toggleEmails)}>
        <VisDiv rules={[title, emailComms?.length > 0]} style={{display:"flex", alignItems:"center", cursor:"pointer", padding:"30px"}}>
            <h2 style={{marginRight:"10px"}}>{title}</h2>
            <VisDiv rules={[!toggleEmails]} >
                <FaArrowAltCircleDown size={25} color={"#324d67"} />
            </VisDiv>
            <VisDiv rules={[toggleEmails]} >
                <FaArrowAltCircleUp size={25} color={"#324d67"} />
            </VisDiv>
        </VisDiv>

        <VisDiv rules={[!title]} style={{backgroundColor: rowColour, display: "flex", padding:"10px", alignItems:"center"}}>
            <div style={{flex: 0.1, alignText:"left"}}>
                <UserIcon
                otherUser={user}
                />
            </div>
            <div style={{marginLeft:"5px", flex: 1, textAlign:"left", }}>
                {userString()}
            </div>
            <div style={{flex: 1, textAlign:"left"}}>
                {nEmails}
            </div>
            <div style={{flex: 2, textAlign:"left"}}>

            </div>
        </VisDiv>
        <VisDiv rules={[toggleEmails]}>
            {emailComms?.map?.((email, index)=>{
                return (
                    <EmailPin email={email} key={email?._id} index={index}/>
                )
            })}
        </VisDiv>

    </div>
    )

}

/**
 * EmailPin component
 * This component renders a single email with its subject, sent and seen dates.
 * The email body is rendered as a RichTextEditor.
 * 
 * @param {Object} email - The email data
 * @param {number} index - The index of the email in the list
 * @returns {JSX} A JSX component with the email data
 */
export const EmailPin = ({email={}, index}) => {

    const [toggleEmail, setToggleEmail] = useState(false)
    const onRowClick = (e) => {
        e.stopPropagation()
        setToggleEmail(!toggleEmail)
        
    }
    const rowColour = index % 2 ? "#FFECBA":"#FFF6DE"
    const {subject, sentOn, seenOn=[], richEditorObj} = email
    const sent = `Spedita: ${DateLog({date: sentOn, justObject: true, dateAndTime: true, justDate: true})}`
    const seen = `Aperta: ${DateLog({date: seenOn?.[0], justObject: true, dateAndTime: true, justDate: true})}`

    return(
        <div onClick={onRowClick} style={{padding: "10px", textAlign:"left", marginLeft:"25px", backgroundColor: rowColour, display: "flex",  alignItems:"center"}}>
            <div>
                <div style={{marginLeft:"5px", flex: 1, textAlign:"left", }}>
                    <h4>
                        {subject}
                    </h4>
                </div>
                <div style={{marginLeft:"5px", flex: 1, textAlign:"left", color:"grey"}}>
                    {sent}
                </div>
                <VisDiv style={{marginLeft:"5px", flex: 1, textAlign:"left", color:"grey"}} rules={[seenOn?.length > 0]}>
                    {seen}
                </VisDiv>
                <VisDiv rules={[toggleEmail]}>
                    <RichTextEditor noFocus={true} existingDoc={richEditorObj} readOnly={true} updateInitialData={true}/> 
                </VisDiv>
            </div>

        </div>
    )
}